'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadMore = function LoadMore(props) {
  var visible = props.visible,
      onClick = props.onClick;


  if (visible) {
    return _react2.default.createElement(
      'div',
      { className: 'pxl-margin-top-md pxl-text-center' },
      _react2.default.createElement(
        'a',
        { className: 'load-more', onClick: onClick },
        'Load More'
      )
    );
  }
  return null;
};

LoadMore.propTypes = {
  onClick: _propTypes2.default.func,
  visible: _propTypes2.default.bool
};

exports.default = LoadMore;